"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _Input = _interopRequireDefault(require("../../../ui/Input"));
var _selectors = require("../../store/selectors");
var _actions = require("../../store/actions");
var _constants = require("./constants");
var _arrow = _interopRequireDefault(require("./arrow.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TourViewControl = function TourViewControl() {
  var searchOfferID = (0, _reactRedux.useSelector)(_selectors.getSearchOfferID);
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var handleTourViewOpen = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.openPageBySearchOfferID)());
  }, [dispatch]);
  var handleKeyPress = (0, _react.useCallback)(function (e) {
    return e.key === 'Enter' && (e.preventDefault(), handleTourViewOpen());
  }, [handleTourViewOpen]);
  var handleChange = (0, _react.useCallback)(function (nextSearchOfferID) {
    return R.call(function (normalizeOfferID) {
      return dispatch((0, _actions.setSearchOfferID)(normalizeOfferID));
    }, R.replace(/\D/g, '', nextSearchOfferID));
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.codeInput,
    "data-value": searchOfferID
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    id: _constants.INPUT_ID,
    placeholder: t('TOUR_VIEW_CONTROL_PLACEHOLDER'),
    value: searchOfferID,
    onChange: handleChange,
    onKeyPress: handleKeyPress
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.submit,
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: handleTourViewOpen
  }));
};
var _default = exports.default = (0, _react.memo)(TourViewControl);